import { textToDateMY } from 'utils/common';

export const googleChartTooltip = (
  date,
  points,
  names,
  colors,
  typeData = ''
) => {
  const curDate = textToDateMY(date);

  return `
      <div style="padding:8px; opacity: 0.9; background-color: #122a57; border-radius:2px;">
        <h4 style="margin: 0; color: #ffffff; font-family: Inter; font-size: 11px;">
          ${curDate}
        </h4>
        ${points.map((point, ind) => {
          return `
            <p style="margin-top: 8px; margin-bottom: 0; display: flex; justify-content: space-between;
            font-family: Inter; font-size: 11px;">
              <span style="margin-right: 8px">
                <span style="display: inline-block; width: 8px; height: 8px; background-color: ${colors[ind]};"></span>
                <span style="color: #ffffff;">${names[ind]}:</span>
              </span>
              <span style="color: #ffffff;">${point}${typeData}</span>
          </p>`;
        })}
      </div>`.replace(/,/g, '');
};
